import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
@Injectable()
export class ToastProvider {
  constructor(public http: HttpClient,
              public toastCtrl: ToastController,) {
  }
  async  presentToastTop(msg) {
    let toast = await this.toastCtrl.create({
        message: msg,
        duration: 3000,
        position: 'top'
    })
    toast.present();
}
async  presentToastBottom(msg) {
  let toast = await this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
  })
  toast.present();
}
}
